import React from 'react';
import DropdownMenu from './DropdownMenu';
import { ReactComponent as Logo } from '../../assets/images/popashot-logo.svg';

const Header = ({ onEditProfile, onLogout, isStaff }) => {
    return (
        <header className="bg-popashot-blue h-16 px-4 flex justify-between items-center fixed top-0 left-0 right-0 z-50">
            <div className="w-48 h-[33px] absolute left-1/2 transform -translate-x-1/2">
                <Logo className="w-full h-full" />
            </div>
            <div className="ml-auto">
                <DropdownMenu
                    trigger={
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                        </svg>
                    }
                >
                {isStaff && (
                    <button
                    onClick={async () => {
                        try {
                            await fetch(`${process.env.REACT_APP_API_URL}/api/users/admin-redirect/`, {
                                method: 'GET',
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                                },
                                credentials: 'include'
                            });
                            window.location.href = `${process.env.REACT_APP_API_URL}/admin/machines/machine/`;
                        } catch (error) {
                            console.error('Failed to redirect to admin:', error);
                            alert('Failed to access dashboard. Please try logging in directly.');
                        }
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                    Dashboard
                    </button>
                )}
                <a
                    href="/profile"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                    Profile
                </a>
                <button
                    onClick={onEditProfile}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                    Edit Profile
                </button>
                <button
                    onClick={onLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                    Sign Out
                </button>
                </DropdownMenu>
            </div>
        </header>
    );
};

export default Header;
